'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { formatNumber, useI18n } from '@udemy-v2/i18n';
import { StarRating } from '@udemy-v2/react-merchandising-components';
import { Tooltip } from '@udemy-v2/react-popup-components';
import styles from './rating-display.module.scss';
import { Icon } from '@udemy-v2/icons';
interface RatingDisplayProps {
  average: number;
  count: number;
  numeric?: boolean;
  isAggregated?: boolean;
}

/**
 * Displays the course rating with stars and count
 */
export const RatingDisplay = t0 => {
  const $ = _c(16);
  const {
    average,
    count,
    numeric,
    isAggregated
  } = t0;
  const {
    gettext,
    interpolate
  } = useI18n();
  let t1;
  if ($[0] !== average || $[1] !== count || $[2] !== gettext || $[3] !== interpolate || $[4] !== isAggregated || $[5] !== numeric) {
    const ratingText = count === 1 ? gettext("rating") : gettext("ratings");
    let t2;
    if ($[7] !== average || $[8] !== numeric) {
      t2 = <StarRating rating={average} showNumber={true} numeric={numeric} borderedStarClassName={styles["star-rating-icon-color-bordered"]} filledStarClassName={styles["star-rating-icon-color"]} />;
      $[7] = average;
      $[8] = numeric;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== gettext || $[11] !== isAggregated) {
      t3 = isAggregated && <Tooltip placement="bottom" renderTrigger={_temp}>{gettext("This rating represents a weighted average of learner ratings across courses belonging to this variant group. Individual course ratings may vary.")}</Tooltip>;
      $[10] = gettext;
      $[11] = isAggregated;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] !== t2 || $[14] !== t3) {
      t4 = <span className={styles["rating-display-container"]}>{t2}{t3}</span>;
      $[13] = t2;
      $[14] = t3;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    t1 = <div className={styles["rating-container"]}>{t4}{count > 0 && <a href="#reviews" className={classNames("ud-text-sm", styles["rating-count"])}>{interpolate(gettext("(%(count)s %(rating_text)s)"), {
          count: formatNumber(count),
          rating_text: ratingText
        }, true)}</a>}</div>;
    $[0] = average;
    $[1] = count;
    $[2] = gettext;
    $[3] = interpolate;
    $[4] = isAggregated;
    $[5] = numeric;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
function _temp(triggerProps) {
  return <span {...triggerProps} className={styles["rating-display-container-tooltip"]}><Icon glyph="info-outline" label={false} /></span>;
}